import React from 'react'

const Parcode = () => {
  return (
    <div>MyParcode</div>
  )
}

export default Parcode

